<template>
    <section>
        <top-banner banner-image="account-confirmation">
            <div class="flex items-center justify-center h-full">
                <div class="text-center pt-2">
                    <h3 class="text-center" v-text="$t('CONFIRMATION_WELCOME_TO')"></h3>
                    <img
                        src="@/assets/images/logos/freddies_flowers_stacked.svg"
                        alt="Freddie's Flowers"
                        class="h-16 md:h-32">

                    <!-- Tiny gap -->
                    <div class="clear--xs"></div>
                </div>
            </div>
        </top-banner>

        <!-- Small gap -->
        <div class="clear--sm"></div>

        <div class="max-w-sm mx-auto text-center">
            <h2 class="pb-4" v-text="$t('CONFIRMATION_DONE')"></h2>
            <p v-text="$t('CONFIRMATION_THANKS')"></p>
            <div class="h-20 pt-2">
                <router-link class="btn btn--primary btn--hoverable" :to="{ name: 'canvasser-register' }">
                    {{ $t('CONFIRMATION_FINISHED') }}
                </router-link>
            </div>
        </div>
    </section>
</template>

<script>
import TopBanner from '@/components/structure/TopBanner';

export default {
    components: {
        TopBanner,
    },
};
</script>
